import { Check } from "lucide-react";
import { QuoteForm } from "./site";
import monteurs from "@/assets/monteurs.png.asset.json";

const benefits = ["Erkende elektriciens", "Gratis en vrijblijvend", "Binnen 5 minuten geregeld"];

// Op mobiel loopt de hero volledig tot aan de zijkanten van het scherm (px-0);
// vanaf md dezelfde bredtes als de gedeelde PAGE_CONTAINER, dus desktop blijft onveranderd.
const HERO_CONTAINER = "mx-auto w-full max-w-[1440px] px-0 md:px-10 lg:px-6 xl:px-10";

export function HomeHero() {
  return (
    <section aria-labelledby="home-hero-title" className="home-hero border-b border-hero-border bg-hero-background text-hero-foreground">
      <div className={`${HERO_CONTAINER} pb-6 pt-0 md:py-10`}>
        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.4fr] lg:grid-cols-2">
          <div className="flex min-w-0 items-center justify-center bg-hero-panel px-6 pb-4 pt-6 md:py-8">
            <img src={monteurs.url} alt="Twee elektriciens met groepenkasten" width={360} height={465} className="h-[240px] w-full select-none object-contain md:h-[440px] lg:h-[480px]" />
          </div>
          <div className="flex min-w-0 flex-col justify-center bg-hero-card px-4 pb-8 pt-6 md:py-8 md:px-8 lg:px-12">
            <h1 id="home-hero-title" className="m-0 text-[26px] font-extrabold leading-tight tracking-normal md:text-[24px] lg:text-[40px]">Vind de beste vakspecialist voor uw elektra klussen</h1>
            {/* Vriendelijke uitleg tussen titel en aanvraagformulier */}
            <p className="mt-3 max-w-[520px] text-[15px] leading-relaxed md:mt-4 md:text-base">
              We staan op het punt de offerte-aanvraag te starten. Dat duurt ongeveer 1 tot 3 minuten. Heb je onderweg vragen? In het account kan je de chat heropenen.
            </p>
            <div className="mt-6"><QuoteForm hero stacked /></div>
            {/* USP-vinkjes alleen op tablet/desktop; op mobiel verborgen */}
            <ul className="mt-5 hidden list-none gap-2.5 p-0 text-sm font-semibold md:mt-5 md:grid">
              {benefits.map((benefit) => <li key={benefit} className="flex min-w-0 items-center gap-2"><Check aria-hidden="true" className="size-4 shrink-0 text-hero-success" strokeWidth={2.4} />{benefit}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
